import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ConfettiBurst } from "@/components/ConfettiBurst";
import { FoundingMakerBadge } from "@/components/FoundingMakerBadge";
import { PartyPopper } from "lucide-react";

export function FoundingMakerCelebration({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  return (
    <>
      <ConfettiBurst run={open} />
      <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
        <DialogContent className="w-[92vw] max-w-md p-6 text-center">
          <div className="flex flex-col items-center gap-3">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-amber-100 to-orange-100 text-amber-600 dark:from-amber-950/50 dark:to-orange-950/50">
              <PartyPopper className="h-7 w-7" />
            </div>
            <div className="flex items-center gap-2">
              <FoundingMakerBadge />
            </div>
            <h2 className="text-xl font-bold leading-tight">You are a Founding Maker</h2>
            <p className="text-sm text-muted-foreground">
              You are one of Stoop's first 50 makers. Here is what you just unlocked:
            </p>
            <ul className="mt-1 space-y-2 text-left text-sm">
              <li className="flex gap-2">
                <span className="text-amber-500">✺</span>
                <span>
                  <strong>0% seller fees for 6 months.</strong> Keep more of every sale during
                  your founding window.
                </span>
              </li>
              <li className="flex gap-2">
                <span className="text-amber-500">✺</span>
                <span>
                  <strong>A permanent Founding Maker badge</strong> on your profile and listings.
                </span>
              </li>
              <li className="flex gap-2">
                <span className="text-amber-500">✺</span>
                <span>
                  <strong>10 free-delivery slots to share.</strong> Your first 10 customers get free
                  delivery on their first 2 orders ($15+) when they use your code.
                </span>
              </li>
            </ul>
            <Button className="mt-3 w-full" onClick={onClose}>
              Let's go
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
